import React from 'react';
import * as PropTypes from 'prop-types';

export const Step = ({
  stepName,
  activeStep,
  children,
}) => (
  <>
    {stepName === activeStep && children}
  </>
);

Step.propTypes = {
  stepName: PropTypes.string.isRequired,
  activeStep: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
};
